module.exports = __webpack_public_path__ + "img/36000.bc8a3785.jpg";